import styled from '@emotion/styled'

const HtmlVideoContainerStyled = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  video {
    // width: 100%;
    // height: 100%;
    width: auto;
    outline: 0;
  }
  video::-webkit-media-controls-start-playback-button {
    display: none;
  }
  video::-webkit-media-controls {
    display: none;
  }
  video::-webkit-media-controls-panel {
    display: none;
  }
  video::-webkit-media-controls-play-button {
    display: none;
  }
`

export { HtmlVideoContainerStyled }
